import styled from '@emotion/styled';
import { MenuItemProps, grey, tokens } from '@galaxy-react/core';
import Typography from 'src/Shared/Components/Typography';
import { StyledGlobalMenuItem } from './global-menu-item.styled';
type GlobalMenuItemProps = MenuItemProps & {
  isSelected?: boolean;
  isSubMenuItem?: boolean;
  handleSelect?: (event: React.MouseEvent<HTMLDivElement>) => void;
  Path?: string;
  content?: React.ReactNode;
  description?: React.ReactNode;
};

const StyleDesc = styled('div')({
  fontSize: '14px',
  lineHeight: '20px',
  color: grey[600],
  width: '100%',
  marginTop: 8,
});

export const StyledTag = styled('span')<{ disabled?: boolean }>({
  display: 'flex',
  alignItems: 'center',
  padding: '2px 8px',
  textAlign: 'center',
  background: '#E5EDF3',
  color: '#014F8C',
  borderRadius: 4,
  whiteSpace: 'normal',
  wordBreak: 'break-word',
  lineHeight: 1.6,
  fontWeight: tokens.fontWeightSemibold,
  fontSize: tokens.fontSizeBase200,
});
export function GlobalMenuItem(props: GlobalMenuItemProps) {
  const { Path, ...rest } = props;
  return (
    // @ts-ignore
    <StyledGlobalMenuItem {...rest}>
      <a
        href={Path}
        onClick={(e) => e.preventDefault()}
        style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}
      >
        <Typography
          type={!props.isSubMenuItem ? 'default' : 'brand'}
          variant={!props.isSubMenuItem ? 'bodyLargeStrong' : 'body'}
        >
          {props.title}
        </Typography>
      </a>
      {props.description && <StyleDesc>{props.description}</StyleDesc>}
    </StyledGlobalMenuItem>
  );
}

export default GlobalMenuItem;
